module.exports = __webpack_public_path__ + "img/first-image-msg.a2d087c6.png";